import * as THREE from 'three';
import { buildSD150 } from '../scene/rails';
import { dividerArray } from './dividerArray';
import { runMeasurements } from './runMeasurements';
import { applyMetricUVs } from '../scene/materialGeometry';
import { isSDSourceDesign } from './sd150Layout';
import { makeSD150Custom } from './sd150CustomModel';
import { buildInsectScreen } from '../scene/insectScreen';
import { hasSlidingMesh } from './slidingOptions';

export function makeSD150Replacement(design, materials, frame) {
  const model = makeSD150Base(design, materials, frame), run = model.runs[0];
  if (hasSlidingMesh(design)) {
    run.screen = buildInsectScreen(run.group, run.width, run.height, run.depth, frame, materials.steel);
    run.screen.animate(design.screens.a / 100);
    applyMetricUVs(run.screen.root);
  }
  return model;
}

function makeSD150Base(design, materials, frame) {
  if (!isSDSourceDesign(design)) return makeSD150Custom(design, materials, frame);
  const group = new THREE.Group(), width = 2, height = 2, panelWidth = (width - .1) / 2 + .018;
  const originalAnimate = buildSD150(group, { width, height }, frame, materials.glass, materials.steel, materials);
  const panels = [group.getObjectByName('sd150-panel-0'), group.getObjectByName('sd150-panel-1')];
  const bars = dividerArray(group, 2, panelWidth, height, design.dividers, frame, { glassWidth: panelWidth - .068, glassHeight: height - .142, glassCenterY: .097 + (height - .142) / 2 });
  const animate = value => {
    originalAnimate(value);
    const positions = panels.map(panel => ({ x: panel.position.x, z: panel.position.z })); bars(positions); group.userData.panelPositions = positions;
  };
  const measures = runMeasurements(width, height, design.run_a.width_in, false, 'a'); group.add(measures);
  animate(design.openings.a / 100); applyMetricUVs(group);
  return { group, runs: [{ group, measures, animate, screen: null, width, height, panelWidth, count: 2, tracks: 2, depth: .15, side: 'a' }] };
}